import { faExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons';
import { ILocationIssueSummaryResponse } from '@kcftech/prometheustypescriptapiclient';
import {
    TableCell,
    TableExternalLinkIcon,
    TableLink,
    TableRow,
} from 'components/infinite_data_source_table/styled';
import { NoValue } from 'components/no_value/NoValue';
import { LocationText } from 'pages/Corporation/issues/styled';
import { memo } from 'react';
import { formatMetricValue } from 'shared/issue_metrics/utils';
import { getLocationLandingPageRoute } from 'utils/RouteHelper';

type CorporationIssuesTableContentProps = {
    data: ILocationIssueSummaryResponse[];
};

function CorporationIssuesTableContent({ data }: CorporationIssuesTableContentProps) {
    return (
        <>
            {data.map((item: ILocationIssueSummaryResponse) => (
                <TableRow key={item.Location.LocationId}>
                    <TableCell>
                        <TableLink
                            to={getLocationLandingPageRoute(item.Location.LocationId)}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <LocationText>{item.Location.LocationName}</LocationText>
                            <TableExternalLinkIcon
                                icon={faExternalLinkAlt}
                                aria-hidden="true"
                            />
                        </TableLink>
                    </TableCell>
                    <TableCell>
                        {item.IssueSummary.NewIssueCount || <NoValue />}
                    </TableCell>
                    <TableCell>
                        {item.IssueSummary.OpenIssueCount || <NoValue />}
                    </TableCell>
                    <TableCell>
                        {item.IssueSummary.AverageDaysIssueOpened === 0 ? (
                            <NoValue />
                        ) : (
                            formatMetricValue(
                                item.IssueSummary.AverageDaysIssueOpened,
                                'days'
                            )
                        )}
                    </TableCell>
                    <TableCell>
                        {item.IssueSummary.DowntimeHoursSaved === 0 ? (
                            <NoValue />
                        ) : (
                            formatMetricValue(
                                item.IssueSummary.DowntimeHoursSaved,
                                'downtime'
                            )
                        )}
                    </TableCell>
                    <TableCell>
                        {item.IssueSummary.TotalSavings ? (
                            formatMetricValue(item.IssueSummary.TotalSavings, 'savings')
                        ) : (
                            <NoValue />
                        )}
                    </TableCell>
                </TableRow>
            ))}
        </>
    );
}

const memoCorporationIssuesTableContent = memo(CorporationIssuesTableContent);
export { memoCorporationIssuesTableContent as CorporationIssuesTableContent };
